// extracted by mini-css-extract-plugin
export default {"errorsContainer":"TotalError_errorsContainer__2vqOW","error":"TotalError_error__5BbFT"};